import { generateTable } from '../../table/Table';
import { fetchWebApis } from '../../../apis';
import { WEB_API_METHODS } from './WebApiForm';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).startsWith('slug', 'slug').equals('method', 'method').end();

var dataSource = function dataSource(_ref) {
  var kappSlug = _ref.kappSlug;
  return {
    fn: fetchWebApis,
    clientSide: clientSide,
    params: function params() {
      return [{
        kappSlug: kappSlug,
        include: 'details'
      }];
    },
    transform: function transform(result) {
      return {
        data: result.webApis
      };
    }
  };
};

var filters = function filters() {
  return function () {
    return [{
      name: 'slug',
      label: 'Slug',
      type: 'text'
    }, {
      name: 'method',
      label: 'Method',
      type: 'select',
      options: function options() {
        return WEB_API_METHODS.map(function (el) {
          return {
            value: el,
            label: el
          };
        });
      }
    }];
  };
};

var columns = [{
  value: 'slug',
  title: 'Slug',
  sortable: true
}, {
  value: 'method',
  title: 'Method',
  sortable: true
}, {
  value: 'createdAt',
  title: 'Created',
  sortable: true
}, {
  value: 'createdBy',
  title: 'Created By'
}, {
  value: 'updatedAt',
  title: 'Updated',
  sortable: true
}, {
  value: 'updatedBy',
  title: 'Updated By'
}];
export var WebApiTable = generateTable({
  tableOptions: ['kappSlug'],
  columns: columns,
  filters: filters,
  dataSource: dataSource
});
WebApiTable.displayName = 'WebApiTable';